<template>
  <section class="sec cta-sec">
    <div class="col grade">
      <div class="bloco principal">
        <span class="tag">Para quem precisa despachar</span>
        <h2>Peça uma coleta<br>para hoje.</h2>
        <p>
          Diga origem, destino e o que vai ser transportado. Você recebe valor
          fechado e janela de coleta antes de qualquer deslocamento.
        </p>
        <div class="acoes">
          <router-link to="/solicitar" class="btn btn--azul">Pedir coleta →</router-link>
          <a :href="wa" target="_blank" rel="noopener" class="btn btn--claro">
            <v-icon size="18">mdi-whatsapp</v-icon> WhatsApp
          </a>
        </div>
      </div>

      <div class="bloco secundario">
        <span class="tag">Para quem dirige</span>
        <h3>Tem veículo e quer rodar com a gente?</h3>
        <p>
          Trabalhamos com motoristas parceiros na Grande São Paulo. Valor combinado
          antes da viagem e pagamento em até 10 dias úteis após a entrega.
        </p>
        <router-link to="/parceiro" class="link">Ver condições de parceria <span>→</span></router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import { waLink } from '@/config/contato'
const wa = waLink('Olá! Preciso de uma coleta.')
</script>

<style scoped>
.cta-sec { background: var(--nevoa); }
.grade { display: grid; grid-template-columns: 1.2fr 1fr; gap: 22px; }

.bloco { border-radius: var(--r); padding: 44px 42px; }

.principal {
  background: linear-gradient(130deg, var(--noite) 0%, var(--noite-3) 100%);
  color: #fff;
  position: relative;
  overflow: hidden;
}
/* brilho diagonal sutil — profundidade, não glow */
.principal::after {
  content: ''; position: absolute; top: -40%; right: -10%;
  width: 60%; height: 180%;
  background: linear-gradient(105deg, transparent, rgba(104, 182, 255, .10), transparent);
  transform: rotate(8deg);
  pointer-events: none;
}
.principal .tag { color: var(--azul-cl); }
.principal h2 {
  font-size: clamp(28px, 3.4vw, 42px);
  font-weight: 800;
  margin-bottom: 16px;
}
.principal p { font-size: 15.5px; line-height: 1.62; color: var(--texto-cl); max-width: 420px; }
.acoes { display: flex; flex-wrap: wrap; gap: 12px; margin-top: 30px; position: relative; z-index: 1; }

.secundario {
  background: #fff;
  border: 1px solid var(--fio);
  box-shadow: var(--sombra-s);
}
.secundario h3 { font-size: 22px; font-weight: 800; margin-bottom: 14px; }
.secundario p { font-size: 14.5px; line-height: 1.62; color: var(--texto); }
.link {
  display: inline-flex; align-items: center; gap: 8px;
  margin-top: 22px;
  color: var(--azul-esc); text-decoration: none;
  font-weight: 700; font-size: 14.5px;
}
.link span { transition: transform .25s var(--ease); }
.link:hover span { transform: translateX(4px); }

@media (max-width: 900px) {
  .grade { grid-template-columns: 1fr; }
  .bloco { padding: 34px 26px; }
  .principal p { max-width: none; }
}
</style>
